import { render, staticRenderFns } from "./addGood.vue?vue&type=template&id=8e143de4&scoped=true&"
import script from "./addGood.vue?vue&type=script&lang=js&"
export * from "./addGood.vue?vue&type=script&lang=js&"
import style0 from "./addGood.vue?vue&type=style&index=0&id=8e143de4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e143de4",
  null
  
)

export default component.exports